import { IDeThiInProgressRequest } from "../../../../model/request/de-thi/de-thi-in/IDeThiInProgressRequest";
import { ISMT_DeThiIn_Request } from "../../../../model/request/de-thi/de-thi-in/ISMT_DeThiIn_Request";
import { ISMT_DeThiIn_Vm } from "../../../../model/respone/de-thi/de-thi-in/ISMT_DeThiIn_Vm";
import { IDeThiInViewFileModalProps } from "../../../../pages/de-thi/de-thi-in/de-thi-in/DeThiInViewFileModal";
import { generateActionTypeIds } from "../../generateActionTypeIds";
import IGenericActionType from "../../IGenericActionType";

export const eDeThiInActionsObj = {
  LOAD_START: {} as ISMT_DeThiIn_Request,
  LOAD_SUCCESS: {} as ISMT_DeThiIn_Vm[],
  LOAD_ERRR: "",

  SAVE_START: {} as any,
  SAVE_SUCCESS: {} as ISMT_DeThiIn_Vm,
  SAVE_AND_CONTINUE_SUCCESS: {} as ISMT_DeThiIn_Vm,
  SAVE_ERROR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",

  CHANGE_SU_DUNG_START: 0,
  CHANGE_SU_DUNG_SUCCESS: undefined,
  CHANGE_SU_DUNG_ERROR: "",

  SELECTED_ID: [] as number[],

  SHOW_EDIT_MODAL: {} as undefined | ISMT_DeThiIn_Vm,
  CLOSE_EDIT_MODAL: undefined,

  CHANGE_REQUEST: {} as any,

  SHOW_PROGRESS_MODAL: {} as number[],
  CLOSE_PROGRESS_MODAL: undefined,

  SHOW_VIEW_FILE_MODAL: {} as undefined | IDeThiInViewFileModalProps,

  DELETE_MULTIPLE_START: {} as number[],
  DELETE_MULTIPLE_SUCCESS: undefined,
  DELETE_MULTIPLE_ERROR: "",

  PROGRESS_START: {} as IDeThiInProgressRequest,
  PROGRESS_SUCCESS: undefined,
  PROGRESS_ERRR: "",
};
export const eDeThiInActionIds = generateActionTypeIds(
  eDeThiInActionsObj,
  "DE_THI_IN"
);
export type IDeThiInActionTypes = IGenericActionType<
  typeof eDeThiInActionsObj,
  "DE_THI_IN"
>;
